var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Survey',{attrs:{"survey":_vm.survey}})
}
var staticRenderFns = []

export { render, staticRenderFns }